/**
 * @file An example of how to use the date picker input component.
 */
import { Form, FormProvider, SuperSchema } from '@updater/ui-informant';

export const schema: SuperSchema = {
  type: 'object',
  properties: {
    dateOfBirth: {
      type: 'string',
      ui: {
        component: 'datePicker',
        label: 'Date',
        width: 0.5,
        componentProps: {
          minDate: '02/02/2022',
          maxDate: new Date(),
        },
      },
    },
  },
};

export const MyForm = () => {
  const handleSubmit = (values: unknown) => {
    alert(`Submitted values: ${JSON.stringify(values, null, 2)}`);
  };

  return (
    <>
      <FormProvider schema={schema} onSubmit={handleSubmit}>
        <Form />
      </FormProvider>
    </>
  );
};
